import React from 'react'
import { MenuItemContainer, ContentContainer, Title, Description } from './MenuItem.styles'
import EditIcon from '../EditIcon/EditIcon'
import LinkIcon from '../LinkIcon/LinkIcon'

export interface MenuItemProps {
    title: string
    description?: string
    onClick?: () => void
    iconType?: 'arrow' | 'edit' | 'link'
}

const ArrowIcon: React.FC = () => {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="1" width="31" height="31" rx="15.5" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M16.175 12.4755C16.4093 12.2412 16.7892 12.2412 17.0235 12.4755L20.6235 16.0755C20.8578 16.3099 20.8578 16.6898 20.6235 16.9241L17.0235 20.5241C16.7892 20.7584 16.4093 20.7584 16.175 20.5241C15.9406 20.2898 15.9406 19.9099 16.175 19.6755L18.7507 17.0998L11.7992 17.0998C11.4678 17.0998 11.1992 16.8312 11.1992 16.4998C11.1992 16.1684 11.4678 15.8998 11.7992 15.8998H18.7507L16.175 13.3241C15.9406 13.0898 15.9406 12.7099 16.175 12.4755Z" fill="#0022E6" />
            <rect x="0.5" y="1" width="31" height="31" rx="15.5" stroke="#E4E7ED" />
        </svg>
    )
}

const MenuItem: React.FC<MenuItemProps> = ({ title, description, onClick, iconType = 'arrow' }) => {
    return (
        <MenuItemContainer
            $isClickable={!!onClick}
            onClick={onClick}
        >
            <ContentContainer>
                <Title>{title}</Title>
                {description && <Description>{description}</Description>}
            </ContentContainer>
            {iconType === 'edit' && <EditIcon />}
            {iconType === 'arrow' && <ArrowIcon />}
            {iconType === 'link' && <LinkIcon />}
        </MenuItemContainer>
    )
}

export default MenuItem
